import React, { Component } from 'react';
import { Avatar, Box, CardHeader, Fab, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { AddRounded, ArrowForwardRounded, ChairRounded, HandymanRounded, LocalShipping, PersonAddAlt1Rounded, PersonRemoveAlt1Rounded, PinDropRounded, QrCode, QrCode2Rounded, TaskRounded } from '@mui/icons-material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import Dialog from '../../common/Dialog';
import TitleWithEndAction from '../../common/TitleWithEndAction';
import Equipements from './Forms/Equipements';
import Attribution from './Forms/Attribution';
import { amber, lightGreen, indigo, blue, purple, red, cyan } from '@mui/material/colors';

import { isEmpty } from 'lodash';
import Usage from './Forms/Usage';
import Localisation from './Forms/Localisation';
import ImmoList from './List/ImmoList';
// import MaterielList from './List/MaterielList';
import VehiculeList from './List/VehiculeList';
import EquipementPlanning from './EquipementPlanning';
import Restitution from './Forms/Restitution';
import EquipementSingle from './Single/EquipementSingle';
import SingleList from './Single/SingleList';
import EquipementUsers from './EquipementUsers';

class CardActionEquipement extends Component {
    state = {  }
    render() {
        return (
            <Box p={1}>
                <Paper
                    elevation={0}
                    style={{ cursor: "pointer"}}
                    onClick={this.props.action}
                    className="equipement_button_card"
                >
                    <CardHeader
                        avatar={
                            <Avatar sx={{ bgcolor: this.props.color }}>
                                {this.props.icon}
                            </Avatar>
                        }
                        action={
                            <IconButton aria-label="settings">
                                <ArrowForwardRounded />
                            </IconButton>
                        }
                        title={<Typography variant="button">{this.props.title}</Typography>}
                        // subheader="September 14, 2016"
                    />
                </Paper>
            </Box>
        );
    }
}

class EquipementGeneral extends Component {
    state = { 
        openForm: false,
        openAttribute: false,
        openReturn: false,
        defaultItem: {}, // prefill attribute / return equipement
        openUsage: false,
        openActions: false,
        openLocal: false,
        openSingleList: false,
        type: "",
        openQR: false,
        selected: {},
        openSingle: false, 
        EQUIP: {}, 
        field: "",
        index: 0
    }
    componentDidMount = () => {
        window.scrollTo(0, 0);
        
        if(!this.props.STATE.equipements.fetched && !this.props.STATE.equipements.fetching){
            this.props.fetchEquipements()
        }
        if(!this.props.STATE.vehicules.fetched && !this.props.STATE.vehicules.fetching){
            this.props.fetchVehicules()
        }
        if(isEmpty(this.props.LOCALISATIONS.PARENT)){
            this.props.fetchParentLocalisations()
        }
        if(isEmpty(this.props.LOCALISATIONS.CHILD)){
            this.props.fetchChildLocalisations()
        }
        if(isEmpty(this.props.IMMO_TAGS)){
            this.props.fetchImmoTags()
        }

        if(!this.props.STATE.employees.fetched && !this.props.STATE.employees.fetching){
            this.props.fetchEmployees()
        }
        if(!this.props.STATE.users.fetched && !this.props.STATE.users.fetching){
            this.props.fetchUsers()
        }
        // if(isEmpty(this.props.LOANS)){
        //     this.props.fetchLoans()
        // }
    }
    render() {
        const { openForm, openActions, openAttribute, openReturn, openUsage, openLocal, openQR, defaultItem, openSingle, openSingleList, EQUIP, EQUIPLIST, index } = this.state;

        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Box>
                <TitleWithEndAction
                    title={"Liste des Équipements"}
                    // action={() => this.props.openFormDownload("/extract/equipements")}
                    // actionTitle="Télécharger" 
                    // disabled={this.props.downloading}
                >
                    <Fab 
                        color={"secondary"} 
                        onClick={() => this.setState({ openActions: true })} 
                        title="Nouvel Équipement"
                        size="small"
                    >
                        <AddRounded />
                    </Fab>
                </TitleWithEndAction>
                {openForm && 
                    <Equipements
                        handleClose={()=> this.setState({ openForm: false })}
                        type={this.state.type}
                        {...this.props}
                    />
                }
                {openAttribute && 
                    <Attribution
                        handleClose={()=> this.setState({ openAttribute: false, defaultItem: {} })}
                        {...this.props}
                        defaultItem={defaultItem}
                        // type={this.state.type}
                    />
                }
                {openReturn && 
                    <Restitution
                        handleClose={()=> this.setState({ openReturn: false, defaultItem: {} })}
                        {...this.props}
                        defaultItem={defaultItem}
                        // type={this.state.type}
                    />
                }
                {openUsage && 
                    <Usage
                        handleClose={()=> this.setState({ openUsage: false })}
                        {...this.props}
                        // type={this.state.type}
                    />
                }
                {openLocal && 
                    <Localisation
                        handleClose={()=> this.setState({ openLocal: false })}
                        {...this.props}
                        // type={this.state.type}
                    />
                }
                {openActions &&
                    <Dialog
                        maxWidth="xs"
                        title="Créer"
                        close={()=> this.setState({ openActions: false })}
                    >
                        <CardActionEquipement
                            title="Immobilisation"
                            action={()=> this.setState({ openActions: false, openForm: true, type: "immo" })}
                            color={cyan[300]}
                            icon={<ChairRounded />}
                        />
                        <CardActionEquipement
                            title="Matériel"
                            action={()=> this.setState({ openActions: false, openForm: true, type: "materiel" })}
                            color={blue[300]}
                            icon={<HandymanRounded />}
                        />
                        <CardActionEquipement
                            title="Véhicule"
                            action={()=> this.setState({ openActions: false, openForm: true, type: "vehicule" })}
                            color={purple[300]}
                            icon={<LocalShipping />}
                        />                        
                        <CardActionEquipement
                            title="Attribution / Emprunt"
                            action={()=> this.setState({ openActions: false, openAttribute: true })}
                            color={lightGreen[300]}
                            icon={<PersonAddAlt1Rounded />}
                        />                        
                        <CardActionEquipement
                            title="Restitution"
                            action={()=> this.setState({ openActions: false, openReturn: true })}
                            color={amber[300]}
                            icon={<PersonRemoveAlt1Rounded />}
                        />                        
                        {/* <CardActionEquipement
                            title="Utilisation"
                            action={()=> this.setState({ openUsage: true })}
                            color={indigo[300]}
                            icon={<TaskRounded />}
                        />                         */}
                        <CardActionEquipement
                            title="Localisation"
                            action={()=> this.setState({ openActions: false, openLocal: true })}
                            color={red[300]}
                            icon={<PinDropRounded />}
                        />                        
                    </Dialog>
                }
                {openSingle && EQUIP &&
                    <EquipementSingle
                        {...this.props}
                        {...this.state}
                        close={() => this.setState({ openSingle: false, EQUIP: {}, field: ""})}
                    />
                
                }
                {openSingleList && EQUIPLIST &&
                    <SingleList
                        {...this.props}
                        {...this.state}
                        close={() => this.setState({ openSingleList: false, EQUIPLIST: {}, field: ""})}
                        handleSingle={
                            (item) => this.setState({ openSingle: true, EQUIP: item, field: "loan_equipement"})
                        } 
                        handleOpenAttribute={
                            (item) => this.setState({ openAttribute: true, defaultItem : item})
                        } 
                        handleOpenReturn={
                            (item) => this.setState({ openReturn: true, defaultItem : item})
                        } 
                    />
                
                }
                <SwipeableTabs
                    returnIndex={(index) => this.setState({ index })}
                    labels={["Immo / Matériels", "Véhicules"]}
                    // labels={["Immos", "Matériels", "Véhicules", "Planning"]}
                >
                    {index == 0 ?
                        <ImmoList 
                            handleSingle={
                                (item) => this.setState({ openSingle: true, EQUIP: item, field: "loan_equipement"})
                            } 
                            handleSingleList={
                                (item) => this.setState({ openSingleList: true, EQUIPLIST: item})
                            } 
                            handleOpenAttribute={
                                (item) => this.setState({ openAttribute: true, defaultItem : item})
                            } 
                            handleOpenReturn={
                                (item) => this.setState({ openReturn: true, defaultItem : item})
                            } 
                            {...this.props} 
                        />
                         :
                        <Box></Box>
                    }
                    {/* {index == 1 ?
                        <MaterielList 
                            handleSingle={
                                (item) => this.setState({ openSingle: true, EQUIP: item, field: "loan_equipement"})
                            } 
                            handleSingleList={
                                (item) => this.setState({ openSingleList: true, EQUIPLIST: item})
                            } 
                            {...this.props} 
                        />
                         :
                        <Box></Box>
                    } */}
                    {index == 1 ?
                        <VehiculeList 
                            handleSingle={
                                (item) => this.setState({ openSingle: true, EQUIP: item, field: "loan_vehicule"})
                            } 
                            handleSingleList={
                                (item) => this.setState({ openSingleList: true, EQUIPLIST: item})
                            } 
                            {...this.props} 
                        />
                        :
                        <Box></Box>
                    }
                    {/* {index == 2 ?
                        <EquipementUsers {...this.props} />
                        :
                        <Box></Box>
                    } */}
                </SwipeableTabs>
            </Box>
        );
    }
}

export default EquipementGeneral;